import axios from 'axios'

export default {
    getEquipment(customerId) {
        return axios.get(`/api/customers/${customerId}/equipment`);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/shared/components/equipmentselector/api.js